import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import './TeamMember.css';

const TeamMember = (member) => {
  const { t, locale } = useI18n();
  const portrait = <img src={member.imageUrl} alt={member.websiteUrl ? t('profile.imageAlt') : member.name} className="member-image" />;
  return (
    <div className="team-member">
      {member.profilePath ? (
        <Link to={getLocalizedPath(member.profilePath, locale)}>{portrait}</Link>
      ) : (
        <a href={member.profileUrl} target="_blank" rel="noopener noreferrer">{portrait}</a>
      )}
      <div className="member-text">
        <h3>{member.websiteUrl ? t('profile.name') : member.name}</h3>
        {member.websiteUrl && (
          <div className="member-profile-links">
            <p>{t('profile.role')}</p>
            <p>{t('profile.intro')}</p>
            <a href={member.websiteUrl} target="_blank" rel="noopener noreferrer">{t('profile.visitWebsite')} ↗</a>
            <Link to={getLocalizedPath(member.profilePath, locale)}>{t('profile.readStory')} →</Link>
          </div>
        )}
        {member.websiteUrl ? (
          <>
            <p>{t('profile.yoyo.body')}</p>
            <ul>
              <li>{t('profile.yoyo.twoA')}</li>
              <li>{t('profile.yoyo.regional')}</li>
              <li>{t('profile.yoyo.national')}</li>
            </ul>
          </>
        ) : <div dangerouslySetInnerHTML={{ __html: member.description }}></div>}
      </div>
    </div>
  );
};

export default TeamMember;
